<template>
  <v-container fluid class="admin-page">
      <v-row class="justify-space-between">
        <v-col
        cols="7"
        >
            <h2>{{ formType.text }} Vendor</h2>
        </v-col>
        <v-col cols="2">
            <v-btn type="submit" class="text--futura text--white" dark block @click.prevent="saveVendor()" :loading="buttonLoading" :disabled="buttonLoading">
                {{ formType.value == 'new' ? 'Save' : 'Update' }}
                <template v-slot:loader>
                    <v-progress-circular
                        indeterminate
                        color="black"
                    ></v-progress-circular>
                </template>
            </v-btn>
        </v-col>
      </v-row>
      <Alert />
      <v-row class="crystal-admin-form justify-space-around pt-5">
            <v-col cols="5">
                <label>Company Name: </label>
                <v-text-field
                    solo
                    placeholder="Company Name"
                    v-model="vendor.company_name"
                ></v-text-field>
                <label>First Name: </label>
                <v-text-field
                    solo
                    placeholder="First Name"
                    v-model="vendor.first_name"
                ></v-text-field>
                <label>Middle Name: </label>
                <v-text-field
                    solo
                    placeholder="Middle Name"
                    v-model="vendor.middle_name"
                ></v-text-field>
                <label>Last Name: </label>
                <v-text-field
                    solo
                    placeholder="Last Name"
                    v-model="vendor.last_name"
                ></v-text-field>
                <label>Phone Number: </label>
                <v-text-field
                    solo
                    placeholder="Phone Number"
                    prefix="+62 | "
                    v-model="phone_number"
                ></v-text-field>
                <label>Bank Name: </label>
                <v-text-field
                    solo
                    placeholder="Enter Bank Name"
                    v-model="vendor.VendorContact.bank_name"
                ></v-text-field>
                <label>Bank Account Number: </label>
                <v-text-field
                    solo
                    placeholder="Enter bank account number"
                    v-model="vendor.VendorContact.account_number"
                ></v-text-field>
                <label>Bank Branch: </label>
                <v-text-field
                    solo
                    placeholder="Enter bank branch"
                    v-model="vendor.VendorContact.bank_branch"
                >
                </v-text-field>
                <label>Bank Account Name: </label>
                <v-text-field
                    solo
                    placeholder="Enter bank account name"
                    v-model="vendor.VendorContact.account_name"
                >
                </v-text-field>
            </v-col>
            <v-col cols="5">
                <label>Email: </label>
                <v-text-field
                    solo
                    placeholder="Enter your email"
                    v-model="vendor.VendorContact.email"
                ></v-text-field>
                <label>Gender: </label>
                <v-row class="justify-start">
                    <v-radio-group
                        v-model="vendor.gender"
                        row
                    >
                        <v-radio label="Male" value="0"></v-radio>
                        <v-radio label="Female" value="1"></v-radio>
                    </v-radio-group>
                </v-row>
                <label>Address: </label>
                <v-textarea
                    solo
                    placeholder="Address"
                    v-model="vendor.VendorContact.address"
                ></v-textarea>
                <label>Province: </label>
                    <v-autocomplete
                        solo
                        placeholder="Province"
                        v-model="vendor.VendorContact.province_id"
                        :items="provinces"
                        item-text="name"
                        item-value="province_id"
                    ></v-autocomplete>
                    <div
                        v-if="vendor.VendorContact.province_id"
                    >
                        <label>City: </label>
                        <v-autocomplete
                            solo
                            placeholder="City"
                            v-model="vendor.VendorContact.city_id"
                            :items="cities"
                            item-text="name"
                            item-value="city_id"
                        >
                            <template slot="selection" slot-scope="data">
                                <!-- HTML that describe how select should render selected items -->
                                {{ data.item.type }} {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                                <!-- HTML that describe how select should render items when the select is open -->
                                {{ data.item.type }} {{ data.item.name }}
                            </template>
                        </v-autocomplete>
                    </div>
                    <label>Postal Code:</label>
                    <v-text-field
                        solo
                        placeholder="Enter Postal Code"
                        v-model="vendor.VendorContact.postal_code"
                    ></v-text-field>
                <label>Tax Status: </label>
                <v-select
                    solo
                    placeholder="Enter Tax Status"
                    v-model="vendor.VendorContact.tax_status"
                    :items="tax_statuses"
                >
                </v-select>
            </v-col>
      </v-row>
      <v-row class="justify-end">
          <v-col cols="2">
              <v-btn type="submit" class="text--futura text--white" dark block @click.prevent="saveVendor()" :loading="buttonLoading" :disabled="buttonLoading">
                {{ formType.value == 'new' ? 'Save' : 'Update' }}
                <template v-slot:loader>
                    <v-progress-circular
                        indeterminate
                        color="black"
                    ></v-progress-circular>
                </template>
              </v-btn>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import Alert from '@/components/Alert.vue'

export default {
    name: 'VendorForm',
    components: {
        Alert
    },
    props: {
        vendor: {
            type: Object,
            default: () => {
                return {
                    company_name: '',
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    gender: 0,
                    VendorContact: {
                        email: '',
                        phone_number: '',
                        address: '',
                        account_name: '',
                        account_number: '',
                        bank_branch: '',
                        bank_name: '',
                        province_id: '',
                        city_id: '',
                        tax_status: '',
                    },
                }
            }
        },
        formType: {
            type: Object,
            default: () => {
                return {
                    text: 'Add New',
                    value: 'new'
                }
            }
        },
        buttonLoading: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            tax_statuses: [
                'Non PKP',
                'PKP'
            ],
        }
    },
    methods: {
        saveVendor() {
            this.$emit('saveVendor');
        }
    },
    computed: {
        provinces () {
            return this.$store.state.provinces
        },
        cities () {
            let province_id = this.vendor.VendorContact.province_id
            return this.$store.state.cities.filter(city => city.province_id == province_id)
        },
        phone_number: {
            get: function () {
                return this.vendor.VendorContact ? this.removeCountryCode(this.vendor.VendorContact.phone_number) : '';
            },
            set: function (value) {
                this.vendor.VendorContact.phone_number = value;
            }
        },
    },
    created () {
        this.$store.dispatch('getCities')
        this.$store.dispatch('getProvinces')
    }
}
</script>

<style>

</style>
